import { useConfigStore } from '@stores'

const getPlanUrl = (plan: Plan, projectId: string) => {
  const apiURL = new URL(useConfigStore.getState().apiURL)
  const fullUrl = new URL(`/projects/${projectId}/download/plans/${plan.guid}`, apiURL)

  return fullUrl.toString()
}

export default getPlanUrl
